__turbopack_context__.v({
  "focus_class": "ia0Sva_focus_class",
  "medical_gatekeeper_toggle_btn": "ia0Sva_medical_gatekeeper_toggle_btn",
  "next_year_renwal": "ia0Sva_next_year_renwal",
  "policy_togglebtn_wrapper": "ia0Sva_policy_togglebtn_wrapper",
  "secondary": "ia0Sva_secondary",
  "toggle_btn": "ia0Sva_toggle_btn",
});
